import { autoserialize } from 'cerialize';

export class AccountTypeModel {
    @autoserialize public loginFlow: string;
    @autoserialize public platform: string;
    @autoserialize public clientId: string;
    @autoserialize public ssoClientId?: string;
    @autoserialize public issuerUrl?: string;
}
